import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import Section from './Section.js'
import MainFormContainer from '../containers/MainFormContainer.js';
import AuthFormContainer from '../containers/AuthFormContainer.js';
import HowItWorks from '../components/HowItWorks.js';
import MinSpecs from '../components/MinSpecs.js';
import Faq from '../components/Faq.js';
import CustomSpinner from './CustomSpinner';
import axios from 'axios';

class Main extends Component {

    constructor(props){
        super(props);
        this.authFromToken = this.authFromToken.bind(this);
        this.state = {
                        isEmailMissing: false,
                        errorMessage: null,
                        isLoading: false,
                        accessToken: null,
                        sellerCode: false
                    };
    }

    componentWillMount() {
        if (this.props.location.query.token) {
            this.setState({ isLoading: true });
            this.authFromToken();
        }
    }

    authFromToken() {

        const jwt = this.props.location.query.token
        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };


        axios.get(`${ROOT_URL}/leads/jwt/${jwt}`, config)
            .then(res => {
                this.setState({
                    accessToken: res.data['access_token']
                });
                sessionStorage.setItem('jwtToken', res.data['access_token']);
                sessionStorage.setItem('jwtUrl', jwt);
                this.props.requestNextStep();
            }).catch(error => {
                switch(error.response.status) {
                    case 422:
                        this.setState({
                            isLoading: false,
                            isEmailMissing: false,
                        });
                        break;
                    case 404:
                        this.setState({
                            isLoading: false,
                            isEmailMissing: false,
                        });
                        break;
                    case 401:
                        sessionStorage.setItem('jwtAuthToken', jwt);
                        this.setState({
                            isLoading: false,
                            isEmailMissing: true,
                            errorMessage: error.response.data.email[0]
                        });
                        break;
                    case 409:
                        this.setState({
                            isLoading: false,
                            isEmailMissing: false,
                        });
                        break;
                    default:
                        this.setState({
                            isLoading: false,
                            isEmailMissing: false,
                        });
                        break;
                }
            });
    }

    showCodeField = (childData) => {
        this.setState({sellerCode: childData})
    }

    render() {
        return (
            <div>
                <Section className="intro_form">
                    <div className="row">
                        <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                            <div className="header-img" >
                                <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                            </div>
                            <div className="header-message custom-padding-titles">
                                <FormattedHTMLMessage id="app.intro" description="Introducción" />
                                <FormattedHTMLMessage id="app.intro_start" description="Introducción" />
                            </div>
                        </div>
                        <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                            {this.state.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere.... Por favor espere...' /> }
                            {this.state.isEmailMissing ? (
                                <AuthFormContainer/>
                            ) : (
                                <MainFormContainer sellerCode={this.state.sellerCode} />
                            )}
                        </div>
                    </div>
                </Section>
                <HowItWorks showCodeField={this.showCodeField} />
                <MinSpecs/>
                <Faq/>
            </div>
        );
    }
}

export default Main;



/** WEBPACK FOOTER **
 ** ./src/components/Main.js
 **/